/**
 * Main App Component
 * 
 * This is the main application component that handles routing,
 * authentication, and high-level layout structure.
 */

import React from 'react';
import { AppProvider } from './context/AppContext';
import { TranslationsProvider } from './context/TranslationsContext';
import AppRouter from './routes/AppRouter';
import './App.css';

const App = () => {
  return (
    <AppProvider>
      <TranslationsProvider>
        <AppRouter />
      </TranslationsProvider>
    </AppProvider>
  );
};

export default App;